import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

enum MessageType {
  Default = 'default',
  Error = 'error',
  Warning = 'warning'
}

@Component({
  selector: 'pcs-message-box',
  templateUrl: './message-box.component.html',
  styleUrls: ['./message-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class MessageBoxComponent {
  @Input() icon = '';
  @Input() messageType = MessageType.Default;

  @HostBinding('class.alert')
  private readonly rootClasses = true;

  @HostBinding('class.alert-primary')
  private get isDefault() {
    return this.messageType === MessageType.Default;
  }

  @HostBinding('class.alert-danger')
  private get isError() {
    return this.messageType === MessageType.Error;
  }

  @HostBinding('class.alert-warning')
  private get isWarning() {
    return this.messageType === MessageType.Warning;
  }
}
